import companyicon1 from '@/assets/company/companyicon1.jpg';
import companyicon2 from '@/assets/company/companyicon2.jpg';
import companyicon3 from '@/assets/company/companyicon3.jpg';
import companyicon4 from '@/assets/company/companyicon4.jpg';
import companyicon5 from '@/assets/company/companyicon5.jpg';
import companyicon6 from '@/assets/company/companyicon6.jpg';
import companyicon7 from '@/assets/company/companyicon7.jpg';
import companyicon8 from '@/assets/company/companyicon8.jpg';
import companyicon9 from '@/assets/company/companyicon9.jpg';



// 首页-banner静态文字
export let homeBannerTabs = [{
	title: '获取产品碳足迹认证',
	subTitle: '立即申请',
	description: '通过申请碳足迹认证，开始跟踪您的企业产品碳排放，帮助您提高市场竞争力，展示可持续发展的承诺'
}, {
	title: '计算您的组织碳排放',
	subTitle: '开始核算',
	description: '开始计算您企业的组织碳排放，了解您的企业在能源消耗、运输、生产等方面的碳影响'
}, {
	title: 'CBAM机制合规填报',
	subTitle: '填写报告',
	description: '通过CBAM合规填报，确保您的企业符合欧盟碳关税要求，避免额外费用和贸易限制'
}, {
	title: '参与企业双碳咨询服务',
	subTitle: '获取详情',
	description: '深入解析碳合规要求，掌握碳中和策略，提升碳管理能力，助力企业符合国际国内标准，增强低碳竞争力'
}, ]

// 企业图标
export let companyIcons = [{
	url: companyicon1,
}, {
	url: companyicon2,
}, {
	url: companyicon3,
}, {
	url: companyicon4,
}, {
	url: companyicon5,
}, {
	url: companyicon6,
}, {
	url: companyicon7,
}, {
	url: companyicon8,
}, {
	url: companyicon9,
},  ]

// 评价标准体系构建方向
export let evaluateDirection = [
	{
		icon: 'shuye',
		label: '高效利用资源',
		des: '提高资源利用效率，提升资源循环利用'
	},
	{
		icon: 'shuidi',
		label: '科学节能降碳',
		des: '合理控制能源消耗，积极推进能源转型'
	},
	{
		icon: 'liangbei',
		label: '减少环境污染',
		des: '严格管控生产环境，倡导使用环保材料'
	},
	{
		icon: 'lujing',
		label: '提升产品品质',
		des: '精益求精于品，追本溯源于材'
	},
	{
		icon: 'zuji',
		label: '低碳价值引领',
		des: '识别低碳价值，引领绿色理念'
	},
]

// 评价标准及意义
export let evaluateYiyi = [
	{
		icon: 'hua',
		label: '应对“双碳”以及环保要求',
		des: '应对国家“双碳”政策以及国际航运业减排目标，顺应环保政策要求，为全球客户提供绿色低碳装备'
	},
	{
		icon: 'shuye2',
		label: '推动行业可持续发展',
		des: '推动建立绿色、低碳、可持续的供应链体系，鼓励绿色技术创新应用，提升资源利用效率，降低污染物排放，推动行业可持续发展'
	},
	{
		icon: '',
		label: '增强集装箱产业全球竞争力',
		des: '提升集装箱行业绿色发展水平，确保在国际市场中的绿色引领，提高集装箱行业全球竞争能力'
	},
]

import pingtaiyoushiCover1 from '@/assets/tmp/pingtaiyoushiCover1.jpg'
import pingtaiyoushiCover2 from '@/assets/tmp/pingtaiyoushiCover2.jpg'
import pingtaiyoushiCover3 from '@/assets/tmp/pingtaiyoushiCover3.jpg'
import pingtaiyoushiCover4 from '@/assets/tmp/pingtaiyoushiCover4.jpg'

// 企业图标
export let webInfo = {
	address: '辽宁省大连市中山区高原街56号',
	contact: '业务联系：15040598515（林）、18840842532（张） \n技术咨询：18840842858（刘）、15640921842（郭）',
	// contact: '业务咨询电话：0411-82713906         电话：0411-82377799 \n传真：0411-82377788',
	email: 'ccia@chinaccia.com',
	phone: '0411-82713906',
	companyName: '中国集装箱行业协会',
	copyright: '中国集装箱行业协会',
	pingtaijieshao: '中国集装箱行业绿色低碳公共服务平台是面向集装箱行业打造的开放、公平、权威、专业的公共服务平台。以“赋能行业绿色转型、助力双碳目标实现”为目标，整合构建“标准落地-数据核算-认证服务-标签发放-绿色评价”的全链条服务，为企业提供一站式、专业化绿色低碳解决方案。',
	sidafuwu: [
		{
			name: 'check',
			title: '产品碳足迹核算',
			des: '以统一的核算标准、核算模型和碳因子库支撑产品碳足迹核算，满足生产企业及下游客户需求',
			icon: 'bar',
			iconActive: 'bar2'
		},
		{
			name: 'authentication',
			title: '产品碳足迹认证',
			des: '对产品生命周期的温室气体排放核算结果进行合规验证，为产品碳足迹提供第三方机构权威背书',
			icon: 'renzheng',
			iconActive: 'renzheng2'
		},
		{
			name: 'tag',
			title: '碳足迹标签申请',
			des: '建立集装箱产品碳足迹的统一标尺，以可视化标识呈现产品碳足迹数值和碳排放水平，为下游客户绿色采购提供可靠依据',
			icon: 'yun',
			iconActive: 'yun2'
		},
		{
			name: 'evaluate',
			title: '绿色产品评价',
			des: '多维构建涵盖资源、能源、环境、品质和低碳等方面的绿色评价体系，以绿色产品和绿色标杆产品引导提升行业绿色生产水平',
			icon: 'shuye3',
			iconActive: 'shuye4'
		},
	],
	pingtaiyoushi: [
		{
			id: 'yzsdglfw',
			cover: pingtaiyoushiCover1,
			title: '产品碳足迹全链条服务',
			des: '实现集装箱生产企业与上游供应链企业、下游用户以及认证机构的多方线上协同，提供“核算”“核查”“披露”“查询”的全链条集成服务',
		},
		{
			id: 'cylsxyqfg',
			cover: pingtaiyoushiCover2,
			title: '统一的核算评价体系',
			des: '平台以中国集装箱行业协会组织编制的团体标准为依据，建立行业广泛参与广泛认可的核算评价模型',
		},
		{
			id: 'kxzydhszc',
			cover: pingtaiyoushiCover3,
			title: '权威的碳因子数据库',
			des: '国内外与行业数据三方集成，内置国际知名商业数据库Ecoinvent和本土数据库HiQLCD，以及建设中的中国集装箱行业LCA碳足迹数据库',
		},
		{
			id: 'mxgjhrhhycx',
			cover: pingtaiyoushiCover4,
			title: '国际互认和行业采信',
			des: '国际标准和国内标准双轨衔接，以“真实活动水平数据+合理量化方法学+高质量背景数据”保障产品碳足迹结果可靠性，为国际客户采信奠定了坚实基础',
		},
	]
}

// 用户协议
export let userAgreement = {
	title: '用户协议',
	content: `
		<div style="font-family: Arial, 'Microsoft YaHei', sans-serif; line-height: 1.8; color: #333; max-width: 900px; margin: 0 auto; padding: 20px;">
		  
		  <h1 style="text-align: center;  font-weight: bold; margin-bottom: 10px;">中国集装箱行业绿色低碳公共服务平台</h1>
		  
		  <h2 style="text-align: center;  font-weight: bold; margin-bottom: 30px;">用户协议</h2>
		  
		  <h3 style=" font-weight: bold; margin-top: 30px; margin-bottom: 15px;">总章</h3>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">1.【特别提示】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">本用户协议(以下简称"本协议")由平台运营方为规范用户在平台上的注册、认证流程以及用户的权利义务而制定。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">当用户点击"阅读并同意"后,本协议即构成对平台运营方及用户均有约束力的法律文件。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">用户应认真阅读并遵守本规则,及其他任何适用的平台规则。<span style="text-decoration: underline;">用户务必审慎阅读、充分理解本协议的各项条款内容,特别是免除或者限制平台运营方责任的条款、争议解决和法律适用条款。</span>前述条款可能以加粗字体和加下划线显示,应重点阅读。<span style="text-decoration: underline;">除非用户已阅读并接受本协议和其他平台规则的所有条款,否则用户无权使用平台。用户使用平台即视为用户已充分理解并同意本协议和其他平台规则的约束。用户无权以未阅读或不了解本协议为由主张本协议无效,或要求撤销本协议。</span></p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">2.【适用范围】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">本协议适用于用户在平台上的账户注册、服务使用、服务终止及账户注销。</p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">3.【定义】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">平台运营方:中国集装箱行业协会</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">关联方:指对于任何主体而言,其直接或间接控制的任何其他实体,或者直接或间接地控制该主体或与该主体共同受控制于他人的任何其他实体。"控制"或"受控制"指,通过表决权、合约或其他方式,直接或间接地拥有该主体超过50%以上股权,或对该主体拥有任命董事会、管理层或同等决策机构的管理和决策的权力,或事实上构成实际控制的其他关系。如果该主体是自然人,指其任何直系亲属,包括其配偶、子女、父母、祖父母、或兄弟姐妹。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">平台:指中国集装箱行业绿色低碳公共服务平台,域名为www.cciacfp.com的网站及相应的任何客户端。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">个人用户:指遵守《用户协议》、《隐私政策》、平台规则的,具备完全民事行为能力的,注册成功后的自然人用户。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">企业用户:指遵守《用户协议》、《隐私政策》、平台规则的,经认证通过的企业法人或其他组织用户。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">用户:指完成注册的个人用户及企业用户的统称。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">游客:指未经注册认证的用户。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">平台公告:指平台在遵守法律法规的强制性规定的前提下,根据平台管理、平台整体规划及相关要求、平台现有功能等因素,针对特定服务、在特定地区、特定时限内,针对平台规则及其他与平台运营以及用户使用平台服务有关的事项不时做出的公示说明。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">日:指日历日,为当日00:00:00至23:59:59,且遇周末和法定节假日不顺延。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">工作日:指排除星期六、星期日、中国法定节假日之外的任何一个日历日。</p>
		  
		  <h3 style=" font-weight: bold; margin-top: 30px; margin-bottom: 15px;">第一章 用户的注册</h3>
		  
		  <h4 style=" font-weight: bold; margin-top: 25px; margin-bottom: 15px;">第一节 注册流程</h4>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">4.【游客权限】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">用户未经注册、认证程序前登录平台,仅可作为游客,浏览平台向游客开放的信息和使用向游客开放的功能,但无权限使用平台的任何其他功能。</p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">5.【认证用户权限】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">5.1个人用户:完成相应注册、认证程序后,即成为平台的认证用户。个人用户可浏览平台向认证用户开放的信息和使用向认证用户开放的功能,经认证的个人用户有权浏览平台向用户开放的信息。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">5.2企业用户:经上传企业信息详见【用户认证流程】6.2条款,个人用户可升级成为企业用户后,可以在平台上进行产品碳足迹核算、产品碳足迹认证、碳足迹标签申请、绿色产品评价等相关业务申请,并可查看相关业务流程和业务报告(结果)等由本账号提交的申请、咨询等内容。</p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">6.【用户认证流程】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">6.1用户以自然人身份进行注册后,即可成为平台的个人用户。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">6.2用户上传企业营业执照(彩色复印件或鲜章扫描件),并填写用户基本信息(包括但不限于名称、联系地址、联系方式等)后,经平台审核通过,可以被认证为企业用户。<span style="text-decoration: underline;">企业用户进行认证应视为其陈述、保证和承诺该企业在作为平台用户的整个期间是依据中华人民共和国法律成立并有效存续的企业法人或其他组织。</span></p>
		  
		  <h4 style=" font-weight: bold; margin-top: 25px; margin-bottom: 15px;">第二节 注册时的用户义务</h4>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">7.【诚信义务】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">用户提供注册资料时应履行诚信义务,确保提供的注册资料真实、准确、完整、合法有效,用户注册资料如有变动的,应及时更新其注册资料。<span style="text-decoration: underline;">如果用户提供的注册资料不合法、不真实、不准确、不详尽的,用户需承担因此引起的相应责任及后果,并且平台保留终止用户使用平台各项服务的权利。</span></p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">8.【责任承担】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">如用户提供的任何注册资料侵犯任何第三方的合法权益,用户应当自行承担责任,如由于该等注册资料侵权对平台造成任何损失的,用户应当向平台进行充分赔偿。</span></p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">9.【不得转让】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">用户注册成功后,应当谨慎保存、使用其用户名和密码,不得将账户转让、出租或出借给他人使用,因他人使用的行为而产生的任何法律责任,由用户应承担连带责任。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">如果发现任何人不当使用用户的账户或有任何其他可能危及用户的账户安全的情形时,用户应当立即以有效方式通知平台,要求平台采取措施。同时,<span style="text-decoration: underline;">用户应理解平台对用户的请求采取措施需要合理期限,在此之前,平台对用户的损失不承担责任。</span></p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">10.【信息更新义务】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">用户公示信息发生变更的,用户应当在变更发生后的三个工作日内通过修改用户信息的方将变更情况告知平台,平台将对该等变更信息进行核验,并更新公示的用户信息。</span>在法律允许的范围内,平台运营方有权不时对用户的信息进行核实,用户应当配合该等核实,并提供最新、真实、完整、有效的信息。</p>
		  
		  <h3 style=" font-weight: bold; margin-top: 30px; margin-bottom: 15px;">第二章 平台服务使用的一般性规范</h3>
		  
		  <h4 style=" font-weight: bold; margin-top: 25px; margin-bottom: 15px;">第一节 用户规定</h4>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">11.【用户注意事项】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">11.1用户在平台使用平台服务过程中,实施的所有行为均须遵守国家法律、法规等规范性文件及平台各项规则的规定和要求,不违背社会公共利益或公共道德,不损害他人的合法权益,不违反本协议及相关规则。如果违反前述承诺,产生任何法律后果的,用户应自行承担所有法律责任。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">11.2用户在使用平台服务过程中,应当遵守诚实信用原则,不采取不正当竞争行为,不扰乱平台服务的正常秩序,不从事与平台服务无关的行为。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">11.3用户须保证所有其在平台上传数据的时效性、有效性、真实性、合法性、准确性和非侵权性。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">11.4用户理解并同意:用户注册平台即表示已阅读、理解并同意遵守本协议的所有条款。用户同意,平台有权根据业务情况或者系统客观情况,新增或者更改平台各类产品或服务,变更情况将及时通过平台发布公告进行告知。用户应自行主动留意平台的公告。该等产品或服务的变更,除有另行规定,自发布公告之日起生效。</p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">12.【用户禁止行为】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">用户在使用平台服务的过程中,不得从事下列行为:</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">12.1使用任何装置、软件或例行程序干预或试图干预平台的正常运作或正在平台上进行的任何活动。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">12.2采取任何将导致不合理的庞大数据负载加诸平台网络设备的行动。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">12.3删除平台及其副本上关于著作权的信息。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">12.4对平台进行反向工程、反向汇编、反向编译,或者以其他方式尝试发现网站的源代码。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">12.5对平台运营方拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">12.6使用平台进行任何危害网络安全的行为,包括但不限于:使用未经许可的数据或进入未经许可的服务器/账户;未经允许进入公众网络或者其他人的操作系统并删除、修改、增加存储信息。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">12.7通过修改或伪造网站运行中的指令、数据,增加、删减、变动网站的功能或运行效果,或者将用于上述用途的软件、方法进行运营或向公众传播,无论这些行为是否为商业目的。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">12.8通过平台开发、授权的第三方软件、插件、外挂、系统,登录或使用本网站及服务,或制作、发布、传播上述工具。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">12.9自行或者授权他人、第三方软件对平台及其组件、模块、数据进行干扰。</p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">13.【用户授权】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">用户在平台使用平台服务的过程中,授权平台从事下列行为:</span></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">13.1合理裁量用户是否违反了本协议,并根据本协议的规定予以处理或终止提供服务,且无须事先通知用户或征得用户同意。</span></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">13.2经国家行政或司法机关的生效法律文书确认用户存在违法或侵权行为,或者平台根据自身的判断,认为用户的行为涉嫌违反本协议和/或相关规则的条款或涉嫌违反法律法规的规定的,在必要的范围内,在平台上公示用户该等涉嫌违法或违约行为及已对用户采取的措施。</span></p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">14.【反贿赂】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">用户在使用平台服务期间,应当遵守反贿赂相关的适用法律法规并履行反贿赂相关义务。用户不得为获取任何不正当利益或不正当优势,进行包括但不限于如下之行为:</span></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">14.1向平台运营方及平台员工和/或其关联方提供财务、消费、款待、商业机会或其他有价值之物品。</span></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">14.2向平台运营方及平台员工和/或其关联方提供贷款。</span></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">14.3雇佣平台运营方及平台的任何员工。</span></p>
		  
		  <h4 style=" font-weight: bold; margin-top: 25px; margin-bottom: 15px;">第二节 知识产权保护</h4>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">15.【知识产权授权】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">用户接受本协议后,对于用户提供、上传、发布在平台的文字、图片、照片、视频、音频等任何形式的信息内容的知识产权均不会发生转移。</span></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">用户上传的内容,视为授权平台在服务范围内使用。用户同意平台及其关联方有权存储、使用、复制、修订、编辑用户的上述信息内容。</span></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">用户应确保上传内容的合法性,对于因上传内容引起的法律纠纷,用户应自行承担全部责任。</span></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">根据用户提供的信息内容,通过平台服务所形成的文字、图片等任何形式的服务成果的知识产权属于平台运营方,平台运营方有权进行发布、展示、翻译、分发、推广、出版、发行、信息网络传播。</span></p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">16.【不侵权】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">用户接受本协议的同时,向平台运营方陈述、保证和承诺,其对于在平台上提供、上传、发布的各类信息内容均享有知识产权或相应的使用权。</span></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">用户应确保该等发布在平台上的各类信息不涉及侵犯第三方隐私、知识产权或其他合法权益。否则用户理解并同意,平台有权随时采取相应措施,包括但不限于:要求相关用户作出回应;删除相关侵权信息等。</span></p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">17.【知识产权归属】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">平台所载的资料信息(诸如文字、图表、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件)以及数据资产(包括但不限于订单数据、用户数据、网站流量数据等),所有权均属于平台运营方或其内容提供者,受相关法律的保护。平台上所有内容汇编是平台运营方的财产,受相关法律保护。平台上所有软件都是平台运营方或其软件供应商的财产,受相关法律保护。</p>
		  
		  <h4 style=" font-weight: bold; margin-top: 25px; margin-bottom: 15px;">第三节 违约责任</h4>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">18.【违约情形】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">用户使用平台服务时违反有关法律法规规定的,或用户违反本协议或其他平台规则任何条款的,视为用户违约。</p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">19.【平台措施】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">如果平台发现或收到他人举报投诉用户违反有关法律法规规定,或违反本协议或其他平台规则任何条款的,有权不经通知随时对相关内容进行删除、屏蔽,并视行为情节对违规帐号处以包括但不限于警告、中止全部或部分服务、帐号冻结(注销)、IP地址封禁等处罚,并公告处理结果。</span></p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">20.【责任承担】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">如因用户违反任何法律法规或本协议的任何条款,导致产生任何第三方主张的索赔要求时,用户应当独立承担责任。平台方因用户的前述行为而发生的任何损害、损失、权利要求、诉讼、付款要求、判决、和解、税费、利息、费用和开支(包括但不限于合理的律师费用),用户应当进行赔偿。</span></p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">21.【免责条款】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">21.1平台对于用户自身原因导致账号信息泄露引发的损失,以及用户原因造成的系统故障,不承担责任。</span></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">21.2平台提供的服务可能包含第三方内容或链接到第三方网站,平台不对第三方通过平台提供的信息或服务承担责任。</span></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">21.3如由于在平台控范围之外的因素,包括但不限于,黑客攻击、计算机病毒侵入或发作、系统或通讯网络故障,或其他不可抗力事件,不承担任何法律责任。</span></p>
		  
		  <h3 style=" font-weight: bold; margin-top: 30px; margin-bottom: 15px;">第三章 平台服务的中止或终止</h3>
		  
		  <h4 style=" font-weight: bold; margin-top: 25px; margin-bottom: 15px;">第一节 平台处罚措施</h4>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">用户违反本协议规定或存在重大风险的,平台有权视情节轻重采取相应措施,包括但不限于:警告、限制功能、暂停服务直至注销账号。对用户违规行为导致的损失,用户应自行承担全部责任。</span></p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">22.【中止全部或部分服务及账户的冻结(注销)】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">如出现下列情况,平台有权中止全部或部分服务,或冻结(注销)用户的账户:</span></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">22.1用户违反有关法律法规规定,或违反本协议任何条款的。</span></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">22.2用户自身运营出现重大恶性变故、资金链断裂,或存在重大潜在损失,后续合作风险极大的。</span></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">22.3用户采用不正当手段进行谋利行为,正在被平台运营方查证的。</span></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">22.4用户注册信息中的主要内容不真实、不准确、不完整,或发生变更未及时更新。</span></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">22.5其他平台合理认为应当中止服务,或冻结(注销)账号的行为。</span></p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">23.【IP地址封禁】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">平台在认定用户存在下列违约行为时,有权直接封禁用户的IP的地址:</span></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">23.1平台运营方中止用户全部或部分服务,或冻结用户账户后,用户再一次直接或间接以他人名字注册为平台用户;</span></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">23.2用户采用不正当手段在平台进行谋利行为,无论是否获得利益。</span></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">23.3其它平台合理认为应当终止服务的情况。</span></p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">24.【主动注销】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">如用户自行决定终止在平台上的所有业务,应在联系平台提出账户注销申请,平台注销该用户账户后,视作用户与平台运营方终止了本协议。</span></p>
		  
		  <h4 style=" font-weight: bold; margin-top: 25px; margin-bottom: 15px;">第二节 服务终止后的权利义务</h4>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">25.【平台权利】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">在用户与平台运营方终止本协议后,平台运营方仍享有下列权利:</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">25.1根据相关法律要求,继续保存用户使用平台服务期间的所有服务信息三(3)年或更长时间;</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">25.2用户在使用平台服务期间存在违反法律法规或违反本协议或其他平台规则的行为的,平台仍可依据本协议向用户主张提出相应主张;</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">25.3平台将在法律允许的范围内,记录、保存平台上发布的服务信息、并按照《隐私和信息保护政策》的规定,收集用户使用平台期间所产生的用户信息,平台将严格按照法律法规要求及《隐私和信息保护政策》的规定使用前述信息。</p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">26.【服务异常】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">为避免平台服务过程中因异常情况对行业或社会造成的不利影响,平台有权根据实际情况,决定临时关闭服务等措施。异常情况包含如下内容:</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">26.1不可抗力【指平台所在地(包括办公及机房)或全国其他部分区域出现不能预见、不能避免并不能克服的客观情况,包括但不限于自然原因引起的自然现象,如,火灾、旱灾、地震、风灾、大雪、山崩等;以及由社会原因引起的社会现象,如,战争、动乱、政府干预、罢工、禁运、市场行情等】。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">26.2意外事件【指由平台以外的原因而非其过错引发的偶然事故,包括但不限于电力故障、网络中断、通讯中断等】。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">26.3技术故障【平台通信系统中硬件设备、应用软件等无法正常运行;系统在运行、主备系统切换、软硬件系统及相关程序升级、上线时出现异常;系统被非法侵入或遭受其他人为破坏等情形】。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">26.4平台认定的其他异常情况。</p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">27.【服务异常情况处理原则】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">27.1平台对关闭服务等决定在平台网站首页予以公告。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">27.2因服务异常情况及平台为避免或减轻服务异常情况的不利影响所采取的必要措施造成的损失,平台不承担责任。</p>
		  
		  <h3 style=" font-weight: bold; margin-top: 30px; margin-bottom: 15px;">第四章 附则</h3>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">28.【通知】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">平台运营方可以通过电子邮件、手机短信、传真、平台即时通讯工具的方式向用户在平台注册时提供的电子邮件地址、手机号码、传真号进行通知。通过电子邮件、手机短信或平台即时通讯工具方式进行通知,送达时间以相关电子邮件、手机短信、推送或通讯内容在平台方系统中记载的发出时间为准;通过传真方式进行通知,送达时间为相关传真的发出时间。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">同时,平台方也有权通过平台以公告的方式通知用户与任何平台项下服务有关的任何事宜,用户有义务不时关注平台的公告信息。公告或通知与本协议不一致的,以公告或通知的内容为准。</span></p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">29.【收费】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">用户使用平台服务可能涉及一定的费用,具体收费标准以平台公告为准。用户应按照平台规定及时支付相关费用。对于逾期未支付费用的用户,平台有权暂停或终止服务。</p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">30.【排除不利于起草方的解释原则】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">本协议应以字面意思进行解释。在法律法规允许的范围内,以不利于起草方的解释排除歧义的原则在解释本协议时不被采用。</p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">31.【权利可累计性;放弃】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">本协议项下双方所享有的权利是可累计的,并且所涉主体均可按照其认为适当的频率行使其权利。除非明示放弃或书面变更,本协议项下任一方所享有的权利不可被放弃或者改变。针对前述权利的任何不行使或者延迟行使,均不应被视为对该权利或其他权利的放弃或者变更。针对前述权利的任何瑕疵行使和部分行使,均不应排除对该等权利或其他权利的进一步或者其他行使。任何一方的任何作为、行为或者谈判,均不得以任何方式阻碍该方行使任何此类权利,或构成任何此类权利的中止或变更。</p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">32.【可分割性】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">如果本协议项下任何一项或者多项条款因任何原因被认定为无效或不可执行,该一项或多项条款应被视为与本协议项下的其他规定内容相分割,并且前述无效或不可执行的条款在任何情况下均不应对本协议项下其他条款的效力和执行力产生影响,也不得影响本规则所涉任何一方所享有的权利。在法律允许的范围内,本协议所涉任何一方特此放弃适用任何使得本规则任何规定在任何方面无效或不可执行的任何法律规定的权利。</p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">33.【法律适用及争议解决】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">本协议的成立、生效、履行、解释及纠纷解决,适用中华人民共和国法律(不包括其法律适用法)。</span></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">用户和平台运营方因本协议产生的,或与本规则相关的任何纠纷或争议,首先应友好协商解决。协商不成的,<span style="text-decoration: underline;">有关方应当将纠纷或争议提交至平台运营方企业注册所在地的人民法院通过诉讼的方式解决。</span></p>
		  
		  <p style="margin-bottom: 15px;"><strong style="font-weight: bold;">34.【生效、变更】</strong></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">34.1本协议由您和平台共同签署,与《隐私政策》构成统一整体,具有同等法律效力。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">34.2在符合《电子商务法》或其他适用法律规定的公示要求或其他强制性要求的前提下,平台有权根据需要不时地重述、修改本协议,并以在平台公告的方式提前通知用户。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">34.3用户如不同意相关变更的,用户有权停止使用平台服务并注销账号。</span></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;"><span style="text-decoration: underline;">34.4用户注册和/或使用平台的行为即构成用户对公告及所涉相关规则变更(无论该等规则是否以弹窗形式单独要求买家确认)的无条件确认与接受。</span></p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">34.5变更生效后的本规则对该等规则变更生效前的各方发生的行为或该等行为产生的法律后果均不具有溯及力。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">34.6本协议自用户注册之日起生效,除非根据本协议的规定提前终止。</p>
		  
		  <p style="margin-bottom: 15px;text-indent: 2em;">34.7本协议的最终解释权归平台所有。</p>
		  
		</div>
	`,
}
// 隐私权政策
export let privacyAgreement = {
	title: '隐私权政策',
	content: `
		<div style="font-family: Arial, 'Microsoft YaHei', sans-serif; line-height: 1.8; color: #333; max-width: 900px; margin: 0 auto; padding: 20px;">
		    
			<h1 style="text-align: center;  font-weight: bold; margin-bottom: 10px;">中国集装箱行业绿色低碳公共服务平台</h1>
			
			<h2 style="text-align: center;  font-weight: bold; margin-bottom: 30px;">隐私政策</h2>
		
		    <p style="text-indent: 2em; margin-bottom: 12px;">
		        欢迎您使用中国集装箱行业绿色低碳公共服务平台（以下简称“平台”）。我们深知个人信息对您的重要性，也深知为您的信息提供有效保护是我们业务健康可持续发展的基石。我们致力于维持您对我们的信任，恪守适用法律和我们对您的承诺，尽全力保证您的个人信息安全和合理使用。我们将按照法律、行政法规的要求，采取相关措施，保护您的信息安全可靠。依据我国《电子商务法》《网络安全法》《个人信息保护法》《常见类型移动互联网应用程序必要个人信息范围规定》等法律法规，并参考《信息安全技术个人信息安全规范》（GB/T 35273-2020）等国家标准，我们制定《隐私政策》（以下简称“本隐私政策”）。
		    </p>
		
		    <p style="text-indent: 2em; margin-bottom: 12px;">
		        在您注册成为平台用户、享受我们提供的服务、使用我们的产品时，我们将按照本隐私政策规定，收集、使用、储存、分享、管理您的个人信息，并为您提供访问、更正、注销、删除和保护这些信息的方式。<span style="text-decoration: underline;">在您使用平台服务前请务必仔细阅读本隐私政策（特别是下划线的内容）。您同意隐私政策仅代表您已了解应用提供的功能，以及功能运行所需要的必要个人信息，并不代表您已同意我们可以收集非必要个人信息，非必要个人信息会根据您使用过程中的授权情况单独征求您的同意。</span>如果您对本隐私政策条款或相关事宜有疑问、意见或建议，请通过平台提供的联系方式与我们联系。
		    </p>
		
		    <div style="text-indent: 2em; margin-bottom: 12px;">
		        <p style="font-weight: bold; margin-bottom: 10px;">本隐私政策将帮助您了解以下内容：</p>
		        <p style="margin: 5px 0;">一、<span style="text-decoration: underline;">我们如何收集和使用您的个人信息</span></p>
		        <p style="margin: 5px 0;">二、<span style="text-decoration: underline;">我们如何使用Cookie和同类技术</span></p>
		        <p style="margin: 5px 0;">三、<span style="text-decoration: underline;">数据使用过程中涉及的第三方以及转移、公开个人信息</span></p>
		        <p style="margin: 5px 0;">四、<span style="text-decoration: underline;">我们如何保存及保护您的个人信息</span></p>
		        <p style="margin: 5px 0;">五、<span style="text-decoration: underline;">关于您的权利</span></p>
		        <p style="margin: 5px 0;">六、<span style="text-decoration: underline;">未成年人条款</span></p>
		        <p style="margin: 5px 0;">七、<span style="text-decoration: underline;">隐私政策的修订和通知</span></p>
		        <p style="margin: 5px 0;">八、<span style="text-decoration: underline;">免责条款及其他</span></p>
		        <p style="margin: 5px 0;">九、<span style="text-decoration: underline;">法律适用和纠纷解决</span></p>
		        <p style="margin: 5px 0;">十、<span style="text-decoration: underline;">联系我们</span></p>
		    </div>
		
		    <h2 style=" font-weight: bold; margin-top: 30px; margin-bottom: 15px; color: #000;">
		        一、我们如何收集和使用您的个人信息
		    </h2>
		    <p style="text-indent: 2em; margin-bottom: 10px;">我们提供服务时，可能会收集、储存和使用下列与您有关的信息。</p>
		    <p style="text-indent: 2em; margin-bottom: 10px;">如果您不提供相关信息，可能无法注册成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。</p>
		    <p style="text-indent: 2em; margin-bottom: 10px;">我们会遵循正当、合法、必要、最小化的原则收集信息，当您使用以下服务、功能或设置时，我们会以下列方式收集和使用您的个人信息：</p>
		
		    <h3 style=" font-weight: bold; text-indent: 2em; margin-top: 20px; margin-bottom: 10px; color: #333;">
		        （一）您需要授权我们收集和使用个人信息的功能服务
		    </h3>
		
		    <div style="margin-bottom: 15px;">
		        <p style="text-indent: 2em; font-weight: bold; margin-bottom: 5px;">1、注册、登录</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（1）收集个人信息的范围</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">根据《中华人民共和国网络安全法》等相关法律法规的规定，<span style="text-decoration: underline;">网络运营者为用户提供信息发布、即时通讯等服务，在与用户签订协议或者确认提供服务时，应当要求用户提供真实身份信息；用户不提供真实身份信息的，网络运营者不得为其提供相关服务。</span></p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇的个人信息。</p>
		        
		        <p style="text-indent: 2em; margin-bottom: 10px; ">
		            本隐私政策中涉及的个人信息包括：基本信息（包括<strong>个人姓名、生日、性别、住址、个人电话号码、电子邮箱</strong>）；个人身份信息（包括<strong>身份证、军官证、护照、驾驶证</strong>等）；个人生物识别信息（包括<strong>声纹、面部识别特征</strong>等）；网络身份标识信息（包括<strong>个人信息主体账号、IP地址、个人数字证书</strong>等）；个人财产信息（包括<strong>交易和消费记录、余额</strong>等虚拟财产信息）；<strong>通讯录</strong>；个人上网记录（包括<strong>网页浏览记录、软件使用记录、点击记录</strong>）；个人常用设备信息（包括<strong>硬件型号、设备MAC地址、操作系统类型、软件列表唯一设备识别码（如IMEI/android ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息等在内的描述个人常用设备基本情况的信息）</strong>）；个人位置信息（包括<strong>行程信息、精准定位信息、经纬度</strong>等）；其中，字体加粗部分为涉及的个人敏感信息。
		        </p>
		
		        <p style="text-indent: 2em; margin-bottom: 5px;">您在访问平台时，可匿名浏览平台介绍信息，公告信息和资讯信息，但在您查询平台相应资讯、下载相关文件或享受其他服务时，需要您注册成为平台用户。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">当您使用注册功能时，您需要至少向我们提供您本人的手机号码（手动输入）或电子邮箱（手动输入）用于注册账号，我们将通过向该手机号发送验证码的方式来验证您的身份是否有效；此类信息属于该功能的必要信息，若您不提供，您将无法完成注册。若需升级注册成为企业用户时，我们将补充收集企业的营业执照（彩色复印件或鲜章扫描件）等资料。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">当您成功注册平台账号后，可以使用平台账号登录平台，登录时您需要向我们提供您的平台账号信息。若您不提供这类信息，您将无法登录和享受平台的部分服务。</p>
		    </div>
		
		    <div style="margin-bottom: 15px;">
		        <p style="text-indent: 2em; font-weight: bold; margin-bottom: 5px;">2、运营与运行安全</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">收集个人信息的范围主要为设备信息，当您使用平台应用时，为了保障软件与服务的安全运行我们会收集设备连接信息（浏览器的类型、电信运营商、使用的语言）、系统信息（设备类型、设备型号、操作系统）、网络信息。单独的设备信息是无法识别特定自然人身份的信息。为了从您的各种设备上收集到的信息，我们可能会将它们进行关联，以便我们能在这些设备上为您提供一致的服务。除取得您授权或法律法规另有规定外，我们会将这类信息做匿名化、去标识化处理。若您不提供这类信息，将可能导致平台无法正常运行。</p>
		    </div>
		
		    <h3 style=" font-weight: bold; text-indent: 2em; margin-top: 20px; margin-bottom: 10px; color: #333;">
		        （二）我们可能如何使用收集到的信息
		    </h3>
		    <p style="text-indent: 2em; margin-bottom: 10px;">提供和改进产品和服务。我们使用收集的信息来提供并改进我们及我们的关联公司及其他受信任的第三方提供的产品和服务，并进行必要的业务运营，运营产品或提供服务、评估、维护和改进产品或服务的性能，参与有关我们产品和服务的市场调查活动，开发新的产品或服务、提供客户支持。</p>
		    <p style="text-indent: 2em; margin-bottom: 10px;">为改进我们及我们的关联公司及其他受信任的第三方提供的产品和服务，平台可能会对产品使用情况进行统计和分析。同时，平台可能会与公众共享这些统计信息，以展示我们服务的整体使用趋势，但这些统计信息将不会包含您的任何身份识别信息，信息会做匿名化、去标识化处理。</p>
		
		    <h3 style=" font-weight: bold; text-indent: 2em; margin-top: 20px; margin-bottom: 10px; color: #333;">
		        （三）在以下情形中，根据法律法规及相关国家标准，我们收集、使用个人信息无需征得您的授权同意
		    </h3>
		    <div style="margin-left: 2em; margin-bottom: 10px;">
		        <p>1、与我们履行法律法规规定的义务相关的；</p>
		        <p>2、与国家安全、国防安全直接相关的；</p>
		        <p>3、与公共安全、公共卫生、重大公共利益直接相关的；</p>
		        <p>4、与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
		        <p>5、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
		        <p>6、所收集的个人信息是您自行向社会公众公开的；</p>
		        <p>7、从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开渠道；</p>
		        <p>8、根据您的要求向您提供产品或服务所必需的；</p>
		        <p>9、用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</p>
		        <p>10、为合法的新闻报道所必需的；</p>
		        <p>11、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
		        <p>12、法律、法规规定的其他情形。</p>
		    </div>
		
		    <h3 style=" font-weight: bold; text-indent: 2em; margin-top: 20px; margin-bottom: 10px; color: #333;">
		        （四）我们在符合下列条件之一时，可以对收集您的信息进行必要范围以外的利用
		    </h3>
		    <div style="margin-left: 2em; margin-bottom: 10px;">
		        <p>1、已取得您的书面同意，或通过其他您认可的方式取得同意；</p>
		        <p>2、为免除您在生命、身体或财产方面之急迫危险，以及为免除您的企业财产方面之急迫危险；</p>
		        <p>3、在紧急的情况下，为了保护我们及用户的个人或公众安全。</p>
		    </div>
		
		    <h3 style=" font-weight: bold; text-indent: 2em; margin-top: 20px; margin-bottom: 10px; color: #333;">
		        （五）当我们要将信息用于本隐私政策未载明的其他用途时，会事先征求您的同意
		    </h3>
		    <p style="text-indent: 2em; margin-bottom: 10px;">当我们要将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。我们可能使用您的信息用于安全防范和诈骗监测，以预防、发现、调查欺诈、危害安全、非法或违反与我们的协议、政策或规则的行为，以保护您、我们或我们的关联公司及社会公众的合法权益。</p>
		
		    <h2 style=" font-weight: bold; margin-top: 30px; margin-bottom: 15px; color: #000;">
		        二、我们如何使用 Cookie 和同类技术
		    </h2>
		    <p style="text-indent: 2em; margin-bottom: 10px;">我们使用Cookie和其他类似技术，以提升您使用本服务的体验。当您使用本服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie或匿名标识符，以收集和存储您访问、使用本服务时的信息。<span style="text-decoration: underline;">我们承诺，不会将Cookie用于本隐私政策所述目的之外的任何其他用途。</span></p>
		    <p style="text-indent: 2em; margin-bottom: 10px;">我们使用Cookie和同类技术主要为了实现以下功能或服务：</p>
		    <p style="text-indent: 2em; margin-bottom: 5px;">1、保障产品与服务的安全、高效运转：我们可能会设置认证与保障安全性的Cookie或匿名标识符，使我们确认您是否安全登录服务，或者是否遇到盗用、欺诈及其他不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度；帮助我们统计流量信息，分析页面设计和广告的有效性。</p>
		    <p style="text-indent: 2em; margin-bottom: 5px;">2、帮助您获得更轻松的访问体验：使用此类技术可以帮助您省去重复您填写个人信息、输入搜索内容的步骤和流程（示例：记录搜索、表单填写）。</p>
		    <p style="text-indent: 2em; margin-bottom: 10px;">我们不会将Cookie用于本政策所述目的之外的任何用途。您有权选择接受或拒绝接受Cookie您可以通过修改浏览器设置的方式拒绝接受Cookie，但如果您选择拒绝接受Cookie，则您可能导致您无法登录或使用依赖于Cookie的本平台网络服务或功能。您可根据自己的偏好管理或删除Cookie。您可以清除计算机上保存的所有Cookie，大多数浏览器均为用户提供了清除浏览器缓存数据的功能，您可以在浏览器设置功能中进行相应的数据清除操作。如您进行清除，您可能无法使用由我们提供的、依赖于Cookie的服务或相应功能，但不会影响您使用平台的其他服务或功能。</p>
		
		    <h2 style=" font-weight: bold; margin-top: 30px; margin-bottom: 15px; color: #000;">
		        三、数据使用过程中涉及的第三方以及转移公开个人信息
		    </h2>
		    <p style="text-indent: 2em; margin-bottom: 10px;">我们的服务将由授权第三方提供，<span style="text-decoration: underline;">我们可能会与第三方共享您的个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法原则，正当与最小必要原则，安全审慎原则共享您的个人信息，并且只会共享提供服务所必要的个人信息，提供的个人信息包括您的注册信息。我们的第三方无权将共享的个人信息用于任何其他用途。</span></p>
		
		    <h3 style=" font-weight: bold; text-indent: 2em; margin-top: 20px; margin-bottom: 10px; color: #333;">
		        （一）共享
		    </h3>
		    <p style="text-indent: 2em; margin-bottom: 10px;">除非经过您本人事先授权同意，我们不会向除平台以外的第三方共享您的个人信息，但经过处理无法识别特定个人且不能复原的除外。</p>
		    <div style="margin-bottom: 15px;">
		        <p style="text-indent: 2em; font-weight: bold; margin-bottom: 5px;">1、在下列情况下，经过您的授权同意，我们可能会共享的个人信息：</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（1）产品或服务提供商。当您使用平台中的产品、服务或其他第三方产品与服务时，这些产品与服务可能会使用您授权的相关系统权限，或根据这些产品与服务的功能可能需要您提交个人信息，我们会根据您的授权将使用第三方产品或服务所必需的信息提供给第三方产品或服务提供商，以便其基于相关信息为您提供产品或服务。关于第三方服务具体如何收集、使用您的个人信息，建议您参考第三方服务的相关服务协议及隐私政策。具体第三方共享目的、范围见本隐私政策第一条 我们如何收集和使用您的个人信息第（二）款。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（2）特定服务合作方。我们会按照法律法规及相关国家标准要求，以弹框提示、确认授权、电子协议多种形式征得您的同意，或确认第三方已征得您的同意，您可以授权通过服务器后台传输共享您的个人信息（包括手机号码、昵称、头像）便于免密登录访问或创建第三方账户。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（3）与关联公司共享。为向您提供一致化服务以及便于您进行统一管理，我们可能会将您的个人信息与我们的关联公司共享。但我们只会共享必要的个人信息，如果我们共享您的个人敏感信息或者关联方改变个人信息的使用目的，将再次征求您的授权同意。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">2、对我们与之共享个人信息的公司、组织和个人，我们会对其数据安全环境进行调查，与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">3、您主动与他人共享的信息</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">您可以利用平台的分享功能与微信、其他社交平台好友共享信息，包括您的信息、商品信息结果。请您在使用第三方服务或分享功能前充分考虑信息接收人的信誉情况，并建议您查看您利用的社交网络或第三方服务提供商的隐私声明，以了解他们如何处理您的信息，以便审慎决策。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">4、以下情况我们可以与平台以外的任何公司、组织和个人共享您的个人信息</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（1）事先获得您明确的同意或授权；</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（2）根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必需的情况下进行提供；</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（3）您通过本平台购买商品或服务，我们会根据您的选择，将您的订单信中与交易有关的必要信息共享给相关商品或服务的提供者，以实现您的交易及售后服务需求；</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（4）我们可能会将您授权的个人信息与我们的关联方或第三方共享。但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的第三方无权将共享的个人信息用于任何其他用途。我们的关联方或第三方包括以下类型：</p>
		        <p style="text-indent: 2em; margin-bottom: 5px; padding-left: 1em;">商品或技术服务的供应商。我们可能会将您的个人信息共享给支持我们功能的第三方。这些支持包括为我们的供货或提供基础设施技术服务、物流配送服务、支付服务、数据处理。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px; padding-left: 1em;">第三方商家。我们必须将您的订单信息与交易有关的必要信息与第三方商家共享来实现您向其购买商品或服务的需求，包括为防止欺诈违法活动和减少信用风险，而与其他公司和组织交换信息。不过，这并不包括违反本政策中所做的承诺而为获利目的出售、出租、共享或以其它方式披露的个人信息。</p>
		    </div>
		
		    <h3 style=" font-weight: bold; text-indent: 2em; margin-top: 20px; margin-bottom: 10px; color: #333;">
		        （二）转移
		    </h3>
		    <p style="text-indent: 2em; margin-bottom: 10px;"><span style="text-decoration: underline;">我们不会将您的个人信息转让给除关联公司外的任何公司、组织和个人，但以下情况除外：</span></p>
		    <div style="margin-left: 2em; margin-bottom: 10px;">
		        <p>1、事先获得您的明确授权或同意；</p>
		        <p>2、满足法律法规的要求或强制性的政府要求或司法文书；</p>
		        <p>3、<span style="text-decoration: underline;">如果我们或我们的关联公司涉及合并、分立、清算，资产或业务的收购、出售或转让交易，您的个人信息有可能作为此类交易的一部分而被转移，我们将确保该信息在转移时的机密性，并尽最大可能确保新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</span></p>
		    </div>
		
		    <h3 style=" font-weight: bold; text-indent: 2em; margin-top: 20px; margin-bottom: 10px; color: #333;">
		        （三）公开披露
		    </h3>
		    <p style="text-indent: 2em; margin-bottom: 10px;">在如下情况下，我们将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：</p>
		    <div style="margin-left: 2em; margin-bottom: 10px;">
		        <p>1、经您事先同意或许可，向第三方披露；</p>
		        <p>2、为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；</p>
		        <p>3、根据法律法规、规章或规范性文件的有关规定，或者行政、司法机构的要求，向第三方或者行政、司法机构披露；</p>
		        <p>4、如您出现违反中华人民共和国有关法律法规或者平台服务协议或相关规则的情况，需要向第三方披露；</p>
		        <p>5、如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利义务纠纷；</p>
		        <p>6、在本平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，本平台有权决定向该用户提供其交易对方的联络方式必要信息，以促成交易的完成或纠纷的解决。</p>
		    </div>
		
		    <h3 style=" font-weight: bold; text-indent: 2em; margin-top: 20px; margin-bottom: 10px; color: #333;">
		        （四）依法豁免征得同意提供、公开的个人信息
		    </h3>
		    <p style="text-indent: 2em; margin-bottom: 10px;">在以下情形中，根据法律法规及国家标准，我们向合作方或第三方提供、公开您的个人信息无需事先征得个人信息主体的授权同意：</p>
		    <div style="margin-left: 2em; margin-bottom: 10px;">
		        <p>1、为订立、履行您作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需的；</p>
		        <p>2、为履行法定职责或者法定义务所必需的；</p>
		        <p>3、与国家安全、国防安全直接相关的；</p>
		        <p>4、与公共安全、公共卫生、重大公共利益直接相关的；</p>
		        <p>5、与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
		        <p>6、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人授权同意的；</p>
		        <p>7、所收集的个人信息是您自行向社会公众公开的；</p>
		        <p>8、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开渠道；</p>
		        <p>9、法律、法规规定的其他情形。</p>
		    </div>
		
		    <h2 style=" font-weight: bold; margin-top: 30px; margin-bottom: 15px; color: #000;">
		        四、我们如何保存及保护您的个人信息
		    </h2>
		    <p style="text-indent: 2em; margin-bottom: 10px;">我们将对您所提供的信息进行严格的管理及保护。我们将使用相应的技术和管理措施，来保护您的个人数据，防止您人员的个人信息丢失、被盗用或遭篡改，以实现对数据安全的承诺。</p>
		    <p style="text-indent: 2em; margin-bottom: 10px;">对于您的保密信息，我们将采取以下保护措施。</p>
		    
		    <div style="margin-bottom: 15px;">
		        <p style="text-indent: 2em; font-weight: bold; margin-bottom: 5px;">1、保存期限</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;text-decoration: underline;">在您使用我们的产品与/或服务期间，您的个人信息将在为了实现本政策所述目的之期限内保存，同时将结合法律有强制的留存要求期限的规定确定，如《中华人民共和国电子商务法》要求产品和服务信息、交易信息保存时间自交易完成之日起不少于三年。在超出保存期间后，我们会根据适用法律的要求删除您的个人信息，或进行匿名化处理。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;text-decoration: underline;">当您成功注销平台账户后，我们将对您的个人信息进行删除或匿名化处理。当您或我们协助您删除相关信息后，因为适用的法律和安全技术限制，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并限制对其的任何进一步的处理，直到备份可以删除或实现匿名化。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;text-decoration: underline;">如果我们终止服务或运营，我们会至少提前三十日向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;text-decoration: underline;">如果您连续一年对您的个人数据的处理情况保持被动，我们保留删除您的个人数据的权利。然而，我们始终非常欢迎您重新注册。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">但以下情况除外：</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（1）遵从法律法规有关信息留存的要求（例如：《网络安全法》规定：采取监测、记录网络运行状态、网络安全事件的技术措施，并按照规定留存相关的网络日志不少于六个月）。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（2）出于财务、审计、争议解决等目的需要合理延长期限的。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（3）作为个人信息处理者对相关信息有其他处理需求的。</p>
		        
		        <p style="text-indent: 2em; font-weight: bold; margin-bottom: 5px; margin-top: 10px;">2、保存地域</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">您的个人信息均储存于中华人民共和国境内。如需跨境储存，我们将会严格按照法律法规的规定执行，并单独征得您的授权同意。</p>
		        
		        <p style="text-indent: 2em; font-weight: bold; margin-bottom: 5px; margin-top: 10px;">3、安全措施</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（1）我们会以“最小化”原则收集、使用、存储和传输用户信息，并通过用户协议和隐私政策告知您相关信息的使用目的和范围。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（2）我们会采取适当的符合业界标准的安全措施和技术手段存储和保护您的个人信息，以防止您的信息丢失、遭到被未经授权的访问、公开披露、使用、毁损、丢失或泄漏。我们会采取一切合理可行的措施，保护您的个人信息。我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（3）我们会对员工进行数据安全的意识培养和安全能力的培训和考核，加强员工对于保护个人信息重要性的认识。我们会对处理个人信息的员工进行身份认证及权限控制，并会与接触您个人信息的员工、第三方签署保密协议，明确岗位职责及行为准则，确保只有授权人员才可访问个人信息。若有违反保密协议的行为，会被立即终止与平台的合作关系，并会被追究相关法律责任，对接触个人信息人员在离岗时也提出了保密要求。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（4）我们也请您理解，在互联网行业由于技术的限制和飞速发展以及可能存在的各种恶意攻击手段，即便我们竭尽所能加强安全措施，也不可能始终保证信息的百分之百安全。请您了解，您使用我们的产品或服务时所用的系统和通讯网络，有可能在我们控制之外的其他环节而出现安全问题。</p>
		        
		        <p style="text-indent: 2em; font-weight: bold; margin-bottom: 5px; margin-top: 10px;">4、安全事件通知</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（1）我们会制定网络安全事件应急预案，及时处置系统漏洞、计算机病毒、网络攻击、网络侵入安全风险，在发生危害网络安全的事件时，我们会立即启动应急预案，采取相应的补救措施，并按照规定向有关主管部门报告。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（2）个人信息泄露、毁损、丢失属于特大安全事件，我们会负责定期组织工作组成员进行安全预案演练，防止此类安全事件发生。若一旦不幸发生，我们将按照最高优先级启动应急预案，组成紧急应急小组，在最短时间内追溯原因并减少损失。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（3）在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处理措施、您可自主防范和降低的风险的建议、对您的补救措施。我们将及时将事件相关情况以站内通知、短信通知、电话、邮件您预留的联系方式告知您，难以逐一告知时我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;text-decoration: underline;">（4）如您发现自己的个人信息泄露，尤其是您的账户及密码发生泄露，请您立即通过本隐私政策【九、联系我们】中约定的联系方式联络我们，以便我们采取相应措施。</p>
		        
		        <p style="text-indent: 2em; font-weight: bold; margin-bottom: 5px; margin-top: 10px;">5、个人信息出境</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">个人信息出境是指网络运营者向境外提供在中华人民共和国境内运营中收集的个人信息。我们严格按照法律法规、平台注册协议的要求保护和使用您的个人信息。特别说明，我们不存在个人信息出境的情形。</p>
		    </div>
		
		    <h2 style=" font-weight: bold; margin-top: 30px; margin-bottom: 15px; color: #000;">
		        五、关于您的权利
		    </h2>
		    <p style="text-indent: 2em; margin-bottom: 10px;">按照中华人民共和国相关的法律法规，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利及方式：</p>
		    <div style="margin-bottom: 15px;">
		        <p style="text-indent: 2em; font-weight: bold; margin-bottom: 5px;">1、访问权</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">原则上您可以通过如下方式访问您的个人信息：</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">账户信息：您可以随时登录平台，访问或编辑您的账户中的个人资料信息、更改您的密码、添加安全信息、进行账户关联或身份认证。</p>
		        
		        <p style="text-indent: 2em; font-weight: bold; margin-bottom: 5px; margin-top: 10px;">2、更正权</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">当您发现我们处理的关于您的个人信息有错误时，经对您的身份进行验证，且更正不影响信息的客观性和准确性的情况下，您有权对错误或不完整的信息作出更正或更新。</p>
		        
		        <p style="text-indent: 2em; font-weight: bold; margin-bottom: 5px; margin-top: 10px;">3、删除权</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">在以下情形中，您可以向我们提出删除个人信息的请求：</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（1）如果我们违反法律法规或与您的约定收集、使用、与他人共享或转让您的个人信息；</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（2）如果我们违反法律法规规定或与您的约定，公开披露您的个人信息，您有权要求我们立即停止公开披露的行为，并发布通知要求相关接收方删除相应的信息。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，并要求其及时删除（除非法律法规另有规定，或这些主体已独立获得您的授权）。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">当您或我们协助您删除相关信息后，因为适用的法律和安全技术限制，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并限制对其的任何进一步的处理，直到备份可以清除或实现匿名化。</p>
		        
		        <p style="text-indent: 2em; font-weight: bold; margin-bottom: 5px; margin-top: 10px;">4、撤销权</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">您可以向我们提出撤销个人信息的请求。</p>
		        
		        <p style="text-indent: 2em; font-weight: bold; margin-bottom: 5px; margin-top: 10px;">5、注销权</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">您随时可以申请注销您的平台帐号。一旦您注销平台账号，将无法正常使用平台相应服务，因此请您谨慎操作。我们为了保护您或他人的合法权益会结合您对平台各产品的使用情况判断是否支持您的注销请求。除法律法规另有规定外，注销帐号之后我们将停止为您提供产品和服务，并根据您的要求删除您的个人信息，但不会删除先前以此账号申请的任务的内容。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">为保障安全，对于您上述有行为，可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</p>
		        
		        <p style="text-indent: 2em; font-weight: bold; margin-bottom: 5px; margin-top: 10px;">6、个人信息主体获取个人信息副本</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">您可以随时登录平台，访问或编辑您的账户中的个人资料信息、进行企业认证。如您需要访问您的账户消息，您可以在平台进行信息访问，并通过截屏获取个人信息副本。</p>
		        
		        <p style="text-indent: 2em; font-weight: bold; margin-bottom: 5px; margin-top: 10px;">7、提前获知产品和服务停止运营权</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">平台愿一直陪伴您，若因特殊原因导致平台产品和服务被迫停止运营，我们将提前30日在产品或服务的主页面通告或向您发送电子邮件或其他合适的能触达您的方式通知您，并将停止对您个人信息的收集，同时会按照法律规定对所持有的您的个人信息进行删除或匿名化处理。</p>
		        
		        <p style="text-indent: 2em; font-weight: bold; margin-bottom: 5px; margin-top: 10px;">8、在以下情形中，按照法律法规要求，我们将无法响应您的更正、删除、注销信息的请求：</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（1）与个人信息控制者履行法律法规规定的义务相关的；</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（2）与国家安全、国防安全直接相关的；</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（3）与公共安全、公共卫生、重大公共利益直接相关的；</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（4）与刑事侦查、起诉、审判和执行判决等直接相关的；</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（5）个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（6）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人授权同意的；</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（7）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（8）涉及商业秘密的。</p>
		        
		        <p style="text-indent: 2em; font-weight: bold; margin-bottom: 5px; margin-top: 10px;">9、访问隐私权政策：</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">您可以在注册/登录页面，查看本隐私权政策的全部内容。</p>
		    </div>
		
		    <h2 style=" font-weight: bold; margin-top: 30px; margin-bottom: 15px; color: #000;">
		        六、隐私政策的修订和通知
		    </h2>
		    <h3 style=" font-weight: bold; text-indent: 2em; margin-top: 20px; margin-bottom: 10px; color: #333;">
		        （一）修订
		    </h3>
		    <p style="text-indent: 2em; margin-bottom: 10px;">为了给您提供更优质的服务，本服务将不时更新、变化，我们会适时对本隐私政策进行修订，这些修订构成本隐私政策的一部分并具有等同于本隐私政策的效力，未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。</p>
		    <p style="text-indent: 2em; margin-bottom: 10px;">本政策所指的重大变更包括：</p>
		    <div style="margin-left: 2em; margin-bottom: 10px;">
		        <p>1、我们的服务模式发生重大变化，包括处理个人信息的目的、处理的个人信息类型、个人信息的使用方式；</p>
		        <p>2、我们在所有权结构、组织架构方面发生重大变化，包括业务调整、破产并购引起的所有者变更；</p>
		        <p>3、个人信息共享、转让或公开披露的主要对象发生变化；</p>
		        <p>4、您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
		        <p>5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
		        <p>6、个人信息安全影响评估报告表明存在高风险时。</p>
		    </div>
		
		    <h3 style=" font-weight: bold; text-indent: 2em; margin-top: 20px; margin-bottom: 10px; color: #333;">
		        （二）通知
		    </h3>
		    <p style="text-indent: 2em; margin-bottom: 10px;">在更新本隐私政策后，若您需要继续使用原授权范围对应的产品或服务，需先接受更新后隐私政策。您知悉并确认，如果您不同意更新后的内容，应该停止相应服务的使用，并可选择注销账户信息；如果您继续使用我们提供的服务，视为您同意更新后的隐私政策，并受隐私政策的约束。</p>
		    <p style="text-indent: 2em; margin-bottom: 10px;">我们还会将本政策的旧版本存档，供您查阅。</p>
		    <p style="text-indent: 2em; margin-bottom: 10px;">您可以在登录/注册页面，查看本隐私权政策的全部内容。</p>
		
		    <h2 style=" font-weight: bold; margin-top: 30px; margin-bottom: 15px; color: #000;">
		        七、免责条款及其他
		    </h2>
		    <p style="text-indent: 2em; margin-bottom: 10px;">除上述规定的免责情形外，下列情况时我们亦无需承担任何责任</p>
		    <div style="margin-bottom: 15px;">
		        <p style="text-indent: 2em; margin-bottom: 5px;">1、由于您人员将用户验证码告知他人或与他人共享注册账户，由此导致的任何个人信息/企业信息泄露。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">2、任何由于计算机问题、黑客攻击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭影响网络正常经营之不可抗力而造成的个人信息/企业信息泄露、丢失、被盗用或被篡改。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">3、其他规定：</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（1）本政策所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本政策涵义解释的依据。</p>
		        <p style="text-indent: 2em; margin-bottom: 5px;">（2）本政策部分条款无效或不可执行的，不影响其余条款的效力，其余条款对各方仍然具有约束力。</p>
		    </div>
		
		    <h2 style=" font-weight: bold; margin-top: 30px; margin-bottom: 15px; color: #000;">
		        八、法律适用和纠纷解决
		    </h2>
		    <p style="text-indent: 2em; margin-bottom: 10px;">本条款受中华人民共和国法律管辖，在本条款履行过程中发生争议的，我们将和您友好协商解决，协商未果的，您和我们均同意提交运营方企业注册地人民法院进行起诉。</p>
		
		    <h2 style=" font-weight: bold; margin-top: 30px; margin-bottom: 15px; color: #000;">
		        九、联系我们
		    </h2>
		    <p style="text-indent: 2em; margin-bottom: 10px;">如果您对我们处理您的个人数据有任何意见，或者如果您出于任何其他原因希望与我们联系，可以通过以下方式联系到我们。</p>
		    <p style="text-indent: 2em; margin-bottom: 10px;">联系邮箱：<a href="mailto:ccia@chinaccia.com" style="color: #0066cc; text-decoration: none; border-bottom: 1px solid #0066cc;">ccia@chinaccia.com</a>.</p>
		    <p style="text-indent: 2em; margin-bottom: 10px;">为保障我们高效处理您的问题并及时向您反馈，需要您提交身份证明、有效联系方式和书面请求及相关证据，我们会再次验证您的身份，处理您的请求。</p>
		
		</div>
	`,
}
